var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 24 24","role":"presentation","focusable":"false","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }